import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import Loader from "./layout/loading/loader";
import {Typography, MenuItem, TextField, Button, Box, Paper, Chip} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {heuresActions} from "../../modules/heures/heures.actions.js";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFnsV3";
import {frFR} from '@mui/x-date-pickers/locales';
import {fr} from 'date-fns/locale';
import {usersActions} from "../../modules/users/users.actions.js";
import {useParams} from "react-router-dom";
import moment from "moment-timezone";
import FeuillesTempsHebdoTable from "./rh/feuillesTempsHebdo/FeuillesTempsHebdoTable";
import {helper} from "../../utils/helper.js";
import Constants from "../../utils/constants";

function RHFicheChantier({dispatch, ...props}) {
    const params = useParams()
    const [selectedOperateur, setSelectedOperateur] = useState(null);
    const [selectedPeriode, setSelectedPeriode] = useState(null);

    useEffect(() => {
        // Fetch operateurs if not already loaded
        if (!props.operateurs && !props.loading && !props.error) {
            dispatch(usersActions.fetchOperateurs("?RHFeatureEnabled=true"))
        }

        // Fetch periodes de paie if not already loaded
        if (!props.periodePaies && !props.loading && !props.error) {
            dispatch(heuresActions.fetchPeriodePaies())
        }

        // If operateurId is in URL params, use it
        const operateurId = params.hasOwnProperty("operateurId") ? params.operateurId : null;
        if (operateurId) {
            setSelectedOperateur(operateurId);
            // If we have both operateur and periode, fetch data
            if (selectedPeriode) {
                dispatch(heuresActions.fetchFeuillesTempsHebdo(selectedPeriode, operateurId));
            }
        }
    }, [params, selectedPeriode]);

    const handleApplyFilters = () => {
        if (selectedOperateur && selectedPeriode) {
            dispatch(heuresActions.fetchFeuillesTempsHebdo(selectedPeriode, selectedOperateur));
        }
    };

    return (
        <>
            <Typography variant="h4" gutterBottom>
                Fiche de temps hebdomadaire
            </Typography>

            {/* Filters */}
            {props.operateurs && props.periodePaies && (
                <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
                    {/* Sélecteur d'opérateur */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <TextField
                            select
                            fullWidth
                            label="Sélectionnez un opérateur"
                            value={selectedOperateur || ''}
                            onChange={(e) => setSelectedOperateur(e.target.value)}
                        >
                            {props.operateurs.map((operateur) => (
                                <MenuItem key={operateur.id} value={operateur.id}>
                                    {operateur.libelle}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    {/* Sélecteur de période de paie */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <TextField
                            select
                            fullWidth
                            label="Sélectionnez une période de paie"
                            value={selectedPeriode || ''}
                            onChange={(e) => setSelectedPeriode(e.target.value)}
                        >
                            {props.periodePaies.map((periode) => (
                                <MenuItem key={periode.id} value={periode.id}>
                                    {periode.libelle} ({helper.formatDate(periode.startDate)} - {helper.formatDate(periode.endDate)})
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    {/* Bouton d'application des filtres */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={!selectedOperateur || !selectedPeriode}
                            onClick={handleApplyFilters}
                        >
                            Afficher les données
                        </Button>
                    </Grid>
                </Grid>
            )}

            {/* Color Legend */}
            <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    <Typography variant="subtitle1">
                        Légende des couleurs
                    </Typography>
                    {Constants.RH_STATUT_JOURNEE_DATA.map((statut) => (
                        <Chip
                            key={statut.id}
                            label={statut.label}
                            sx={{
                                backgroundColor: statut.color,
                                color: statut.fontColor,
                                fontWeight: 'bold',
                                minWidth: '100px'
                            }}
                        />
                    ))}
                </Box>
            </Paper>

            {/* Loader */}
            {props.loading && <Loader />}

            {/* Display data */}
            {!props.loading && props.feuillesTempsHebdo && (
                <FeuillesTempsHebdoTable 
                    feuillesTempsHebdo={props.feuillesTempsHebdo} 
                    periodeId={selectedPeriode}
                    operateurId={selectedOperateur}
                />
            )}
        </>
    );
}

const mapStateToProps = function (state) {
    return {
        feuillesTempsHebdo: state.heures.feuillesTempsHebdo,
        operateurs: state.users.operateurs,
        periodePaies: state.heures.periodePaies,
        loading: state.heures.loading || state.users.loading,
        error: state.heures.error || state.users.error
    }
}

export default connect(mapStateToProps)(RHFicheChantier);
